import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createNoteActions } from './actions';
import { NoteActions, NoteState } from './types';

export const useNoteStore = create<NoteState & NoteActions>()(
    immer((set, get, store) => ({
        notes: [],
        loading: false,
        selectedNote: null,
        loadingNote: false,
        error: undefined,
        ...createNoteActions(set, get, store),
    })),
);
